module.exports = __webpack_public_path__ + "static/img/a5e2c56bffc1c78a1b4a9c7d278761ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/page-resource/global/img/account/bg-account.png
// module id = xqHD
// module chunks = 0